export const API_URL = "/cms-engine";
//export const API_URL = "http://cms-dbrt-dev.apps.okd.dorsum.intra/cms-engine";
//export const API_URL = "http://localhost:8081/cms-engine";
export const METER_ENGINE_API_URL = "/meter-engine/meter";
export const MESSAGING_ENGINE_API_URL = "/messaging-engine";
export const PAYMENT_ENGINE_API_URL = "/payment-engine";
export const APPOINTMENT_ENGINE_API_URL = "/appointment-engine";
//export const METER_ENGINE_API_URL = "http://localhost:8082/meter-engine/meter";
